import { render, staticRenderFns } from "./AllOrderList.vue?vue&type=template&id=1d99f9c1&scoped=true"
import script from "./AllOrderList.vue?vue&type=script&lang=js"
export * from "./AllOrderList.vue?vue&type=script&lang=js"
import style0 from "./AllOrderList.vue?vue&type=style&index=0&id=1d99f9c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99f9c1",
  null
  
)

export default component.exports